import {Component, ElementRef, inject} from '@angular/core';
import {LoggerService} from '../shared/services/logger.service';

@Component({
    selector: 'app-sidebar-component',
    template: `
      <div class="layout-sidebar">
        <app-sidebar-menu></app-sidebar-menu>
      </div>
    `,
    standalone: false
})
export class AppSidebarComponent {
    protected readonly logger = inject(LoggerService);
    el = inject(ElementRef);
}

